export default __webpack_public_path__ + "static/media/aurum-logo.1046f59b.png";